import * as d3 from "d3";
import {
    axisTextDim3,
    colonAnnotation, contextMenu,
    createTooltip,
    fw_progressive_1way, generateDownloadData,
    numberFormat,
    responsivefy
} from '../functions'

export default function (chart,divId,vizName,resData, filterParam,checkbox, gridflag, showValuesFlag){

    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    // axios.post(url, filterParam).then(res => {

        let data = resData
        console.log("data", data)


        if(checkbox!=true) { // inverted the logic

            var svg = d3.select(divId)
            svg.selectAll("*").remove();

            svg = d3.select(divId).append("svg")
                .attr("width", chart.width + chart.margin.left + chart.margin.right+140) //extra space to accomodate Legends
                .attr("height", chart.height + chart.margin.top + 2*chart.margin.bottom)
                .call(responsivefy)
                .append("g")
                .attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");


            var xScale = d3.scaleLinear().rangeRound([0, chart.width]).domain([0, 10]),
                yScale = d3.scaleBand().rangeRound([chart.height, 0]).padding(0.1),
                color = d3.scaleOrdinal().range(fw_progressive_1way),
                xAxis = d3.axisBottom(xScale).tickFormat(numberFormat),
                //  xAxis = d3.axisBottom(xScale).tickFormat(d3.format(".0%")),
                yAxis = d3.axisLeft(yScale)

            var wide = d3.nest()
                .key(function (d) {
                    return d["dim1_name"]
                }) // sort by key
                .rollup(function (d) { // do this to each grouping
                    // reduce takes a list and returns one value
                    // in this case, the list is all the grouped elements
                    // and the final value is an object with keys
                    return d.reduce(function (prev, curr) {
                        prev["dim1_name"] = curr["dim1_name"];
                        prev[curr["dim2_name"]] = curr["metric1"];
                        //  console.log(prev,"prev")
                        return prev;
                    }, {});
                })
                .entries(data) // tell it what data to process
                .map(function (d) { // pull out only the values
                    // console.log("widess",d)
                    return d.value;
                });

            //To fill zero values for properties where they exist elsewhere in the array, but not in that object.


// get unique keys
            let objWithAllProp = wide.reduce((acc, item) => ({...acc, ...item}));

// Get keys as an array and Create an object with all keys set to the default value to 0
            let uniqueObjectWithAllProp = Object.keys(objWithAllProp).reduce((acc, key) => {
                acc[key] = 0
                return acc;
            }, {});

// Replace all default values with original, so if key not present in original item, it will be available from uniqueObjectWithAllProp and value default to 0
            let result = wide.map((item) => ({...uniqueObjectWithAllProp , ...item}));

            console.log("Unique data",result)
            console.log("Wide data",wide)
            wide = result

            /*                var key = d3.keys(wide[0]).filter(function (key) {
                                return key !== "dim1_name"
                            });*/
            var key = [...new Set( data.map(obj => obj.dim2_name)) ]

            console.log("keys", key)
            //  let parseDate = d3.timeParse("%m/%Y");

            color.domain(key);

            wide.forEach(function (d) {
                var y0 = 0;
                let tot = 0;
                d.values = color.domain().map(function (name) {
                    console.log("wide loop data", {name: name, y0: isNaN(y0)?0: y0, y1: isNaN(d[name]) ?  y0 =0 : isNaN(y0)? y0 =0 : y0 += d[name]},d[name],y0, isNaN(d[name]), isNaN(y0) )
                    // console.log("wide loop data", {name: name, y0: isNaN(y0)?0:y0, y1: isNaN(d[name])|| isNaN(y0)?0:y0 += +d[name]})
                    return {name: name, y0: y0, y1: y0 += +d[name], tot: tot += +d[name]};
                    // return {name: name, y0: isNaN(y0)?0: y0, y1: isNaN(d[name]) ?  y0 =0 : isNaN(y0)? y0 =0 : y0 += d[name]};

                });
                d.total = d.values[d.values.length - 1].tot;
            });
            wide = wide.sort(function(a,b) { return +a.total - +b.total })
            console.log("Wide y0 data",wide, wide.sort(function(a,b) { return +a.total - +b.total }))
            // wide.forEach(function(d){
            //     // Compute the total
            //     let tot = 0
            //     for (let i in stackKey){ let name=stackKey[i] ; tot += +d[name] }
            //     // Now normalize
            //     for (let i in stackKey){ var name=stackKey[i] ; d[name] = d[name] / tot * 100}
            // })

            let stackKey = key;

            var stack = d3.stack()
                .keys(stackKey)(wide)
                .map(d => (d.forEach(v => v.key = d.key), d));
            // .offset(d3.stackOffsetExpand);

            console.log(stack)

            const tooltip = createTooltip(divId);

            // var layers= stack(wide);
            //   console.log("layers",layers)
            //  wide.sort(function(a, b) { return b.total - a.total; });
            yScale.domain(wide.map(function (d) {
                return d.dim1_name;
            }));
            xScale.domain([0, d3.max(wide, function (d) {
                return d.total;
            })]).nice();

            var layer = svg.selectAll(".layer")
                .data(stack)
                .enter().append("g")
                .attr("class", "layer")
                .style("fill", function (d,) {
                    return color(d.key);
                });

            layer.selectAll("rect")
                .data(function (d) {
                    console.log("rect data",d)
                    return d;
                })
                .enter().append("rect")
                .attr("y", function (d) {
                    return yScale(d.data.dim1_name);
                })
                .attr("x", function (d) {
                    return xScale(d[0]);
                })
                .attr("height", yScale.bandwidth())
                .attr("width", function (d) {
                    return xScale(d[1]) - xScale(d[0])
                })
                .on("mouseover", function(d) {
                    console.log(d3.event, d); // For debugging, log the event and data

                    // Calculate percentage value
                    let pctValue = (100 * ((d[1] - d[0]) / d.data['total'])).toFixed(2);

                    // Call the tooltip's onMouseOver method and pass the data and event
                    tooltip.onMouseOver(d, this, function(d) {
                        // Tooltip content callback
                        return d.data['dim1_name'] + colonAnnotation + d['key'] + ' (' + pctValue + '%)' + colonAnnotation + numberFormat(d[1] - d[0]);
                    });  // Pass the event for positioning
                })
                .on('mousemove', function(event) {
                    tooltip.onMouseMove(event);  // Update tooltip position on mouse move
                })
                .on("mouseout", function() {
                    // Hide the tooltip on mouse out
                    tooltip.onMouseLeave();
                })
                .on('contextmenu', function(d) {

                    // Prepare clickedData with both axes' info
                    const clickedData = {
                        [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]: [d.data['dim1_name']],  // e.g., "2019", "2020"
                        [chart.insightNavigator.realDataFieldNames.y1RealDataFieldName]: [d['key']]               // e.g., "metric1"
                    };
                    // Generate the menu with current config and filters
                    const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                    // Show the context menu
                    contextMenu(menuItems).call(this, clickedData);

                    // Prevent default context menu
                    d3.event.preventDefault();
                });

            if(showValuesFlag){
                //Add value top of the each stacked bar
                layer.selectAll('text.bar')
                    // Enter in the stack data = loop key per key = dim1_name per dim1_name
                    .data(stack)
                    .enter().append("g")
                    .selectAll("rect")
                    // enter a second time = loop subgroup per subgroup to add all rectangles
                    .data(function (d) {
                        return d;
                    })
                    .enter()
                    .append('text')
                    .attr('class', 'bar')
                    .attr('text-anchor', 'middle')
                    .attr('x', (d)=> {return xScale((d[0]+d[1])/2) })
                    .attr('y', (d)=> { console.log("bar data",d); return yScale(d.data.dim1_name) + yScale.bandwidth() / 2 })
                    .attr('dy', '0.35em')
                    .text((d)=> {  return xScale(d[1]) - xScale(d[0]) >25 ? numberFormat(d[1]-d[0]) : '' }) //if the bar height is >25 then show the number
                    // .attr('fill', 'DarkSlateGrey')
                    .attr('fill', 'White')
                    .style('font-size',12)

            }
            // Add total value at the top of the bar
            layer.selectAll("tot.bar")
                // Enter in the stack data = loop key per key = dim1_name per dim1_name
                .data(stack)
                .enter().append("g")
                .selectAll("rect")
                // enter a second time = loop subgroup per subgroup to add all rectangles
                .data(function (d) {
                    return d;
                })
                .enter()
                .append('text')
                .attr('class', 'bar')
                .attr('text-anchor', 'middle')
                .attr('x', (d)=> { console.log("bar total value",d); return xScale(d.data.total)+30  })
                .attr('y', (d)=> {return yScale(d.data.dim1_name) + yScale.bandwidth() / 2 })
                .attr('dy', '0.35em')
                .text((d)=> {  return numberFormat(d.data.total) })
                .attr('fill', 'black')
                .style('font-size',15)


            svg.append("g")
                .attr("class", "axisL14")
                .attr("transform", "translate(0," + (chart.height + 5) + ")")
                .call(xAxis);

            svg.append("g")
                .attr("class", "axisL14")
                .attr("transform", "translate(0,0)")
                .call(yAxis)
                .selectAll('text')
                .text(axisTextDim3); //Legend and Axis titles are not displayed due to Null error fixed in data

            svg.append('text')
                .attr('x', (chart.width / 3))
                .attr('y', chart.height + chart.margin.bottom+ 2*chart.axisLabelDistance)
                .style('fill', 'Black')
                .text(chart.x1AxisDisplayName)
                .style('font-size',15)

            /*                svg.append('text')
                                .attr('x', (chart.width / 2))
                                .attr('y', 0 - (chart.margin.top / 2))
                                .attr('text-anchor', 'middle')
                                .style('fill', fontColor)
                                .text(chart.x2AxisDisplayName)
                                .style('font-size',fontSize -6)*/

            svg.append('text')
                .attr('transform', 'rotate(-90)')
                .attr('y', 0 - chart.margin.left)
                .attr('x', 0 - (chart.height / 3))
                .attr('dy', '1em')
                .style('text-anchor', 'middle')
                .style('fill', 'Black')
                .text(chart.y1AxisDisplayName)
                .style('font-size',15)

            var legend = svg.selectAll(".legend")
                .data(color.domain())
                .enter()
                .append("g")
                .attr("class", "legend")
                .attr("transform", function (d, i) {
                    return "translate(0," + i * 20 + ")";
                });

            legend.append("rect")
                .attr("x", chart.width + 5) //-140
                .attr("width", 15)
                .attr("height", 15)
                .style("fill", color);

            legend.append("text")
                .attr("x", chart.width + 30) //-110
                .attr("y", 9)
                .attr("dy", ".3em")
                .attr("class", "legend")
                .text(function (d) {
                    return d
                });

        }
        else
        {
            svg = d3.select(divId)
            svg.selectAll("*").remove();

            svg = d3.select(divId).append("svg")
                .attr("width", chart.width + chart.margin.left + chart.margin.right)
                .attr("height", chart.height + chart.margin.top + 2*chart.margin.bottom)
                .call(responsivefy)
                .append("g")
                .attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");

            var x1Scale = d3.scaleLinear().range([0, chart.width]),
                y1Scale = d3.scaleBand().range([chart.height, 0]).padding(0.08),
                color1 = d3.scaleOrdinal().range(fw_progressive_1way),
                x1Axis = d3.axisBottom(x1Scale),
                //  xAxis = d3.axisBottom(xScale).tickFormat(d3.format(".0%")),
                y1Axis = d3.axisLeft(y1Scale)


            var wide1 = d3.nest()
                .key(function (d) {
                    return d["dim1_name"]
                }) // sort by key
                .rollup(function (d) { // do this to each grouping
                    // reduce takes a list and returns one value
                    // in this case, the list is all the grouped elements
                    // and the final value is an object with keys
                    return d.reduce(function (prev, curr) {
                        prev["dim1_name"] = curr["dim1_name"];
                        prev[curr["dim2_name"]] = curr["metric1"];
                        //  console.log(prev,"prev")
                        return prev;
                    }, {});
                })
                .entries(data) // tell it what data to process
                .map(function (d) { // pull out only the values
                    // console.log("widess",d)
                    return d.value;
                });

            const tooltip1 = createTooltip(divId);

            /*                var key1 = d3.keys(wide1[0]).filter(function (key) {
                                return key !== "dim1_name"
                            });*/
            var key1 = [...new Set( data.map(obj => obj.dim2_name)) ]

            console.log("keys1", key1)
            //  let parseDate = d3.timeParse("%m/%Y");

            color1.domain(key1);

            let stackKey1 = key1;

            var stack1 = d3.stack()
                .keys(stackKey1)
                .offset(d3.stackOffsetExpand)(wide1)
                .map(d => (d.forEach(v => v.key = d.key), d));

            console.log(stack1)

            y1Scale.domain(wide1.map(function (d) {
                return d.dim1_name;
            }));

            var layer1 = svg.selectAll(".layer")
                .data(stack1)
                .enter().append("g")
                .attr("class", "layer")
                .style("fill", function (d,) {
                    return color1(d.key);
                });

            layer1.selectAll("rect")
                .data(function (d) {
                    return d;
                })
                .enter().append("rect")
                .attr("y", function (d) {
                    return y1Scale(d.data.dim1_name);
                })
                .attr("x", function (d) {
                    return x1Scale(d[0]);
                })
                .attr("height", y1Scale.bandwidth())
                .attr("width", function (d) {
                    return x1Scale(d[1]) - x1Scale(d[0])
                })
                .on("mouseover", function(d) {
                    console.log(d3.event, d); // For debugging, log the event and data
                    var subgroupName = d3.select(this.parentNode).datum().key;
                    var subgroupValue = d.data[subgroupName];
                    let pctValue = ((d[1]-d[0])*100).toFixed(2)

                    tooltip1.onMouseOver(d, this, function(d) {
                        return d.data['dim1_name'] + colonAnnotation + d['key']+ '(' + pctValue+ '%)' + colonAnnotation+ subgroupValue
                    });
                })
                .on('mousemove', function(event) {
                    tooltip1.onMouseMove(event);  // Update tooltip position on mouse move
                })
                .on("mouseout", function() {
                    // Hide the tooltip on mouse out
                    tooltip1.onMouseLeave();
                })
                .on('contextmenu', function(d) {

                // Prepare clickedData with both axes' info
                const clickedData = {
                    [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]: [d.data['dim1_name']],  // e.g., "2019", "2020"
                    [chart.insightNavigator.realDataFieldNames.y1RealDataFieldName]: [d['key']]               // e.g., "metric1"
                };
                // Generate the menu with current config and filters
                const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                // Show the context menu
                contextMenu(menuItems).call(this, clickedData);

                // Prevent default context menu
                d3.event.preventDefault();
            });


            svg.append("g")
                .attr("class", "axisL14")
                .attr("transform", "translate(0," + (chart.height + 5) + ")")
                .call((x1Axis).ticks(chart.width / 100, "%"))
                .call(g => g.selectAll(".domain").remove());

            svg.append("g")
                .attr("class", "axisL14")
                .attr("transform", "translate(0,0)")
                .call(y1Axis)
                .call(g => g.selectAll(".domain").remove())
                .selectAll('text')
                .text(axisTextDim3);

            svg.append('text')
                .attr('x', (chart.width / 3))
                .attr('y', chart.height + chart.margin.bottom+ 2*chart.axisLabelDistance)
                .style('fill', 'Black')
                .text(chart.x1AxisDisplayName)
                .style('font-size',15)

            /*                svg.append('text')
                                .attr('x', (chart.width / 2))
                                .attr('y', 0 - (chart.margin.top / 2))
                                .attr('text-anchor', 'middle')
                                .style('fill', fontColor)
                                .text(chart.x2AxisDisplayName)
                                .style('font-size',fontSize -6)*/

            svg.append('text')
                .attr('transform', 'rotate(-90)')
                .attr('y', 0 - chart.margin.left)
                .attr('x', 0 - (chart.height / 3))
                .attr('dy', '1em')
                .style('text-anchor', 'middle')
                .style('fill', 'Black')
                .text(chart.y1AxisDisplayName)
                .style('font-size',15)

        }
    // })
}